import React, { useState, useEffect, useContext } from "react";
import { Container, Navbar, Row, Col } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { Link, useNavigate, useLocation } from "react-router-dom";
import eNamadImage from "../../../assets/images/e-namad.png";
import NavbarLinkItem from "./NavbarLinkItem";
import ContextApp from "./../../../core/contexts/context.app";
import ApiContact from "../../../core/api/api.contact";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
//import ApiAuth from "../../../core/api/api.auth";

import _ from "lodash";
import {
  IconBasket,
  IconCall,
  IconCategory,
  IconHome,
  IconUser,
  IconClipBoard,
  IconUserCheck,
} from "../../../assets/icons";

function FooterNav() {
  const location = useLocation();

  const ctx = useContext(ContextApp);
  //
  const [isLogin, setIsLogin] = useState(ctx.isAuth);
  const [collapsed, setCollapsed] = useState(true);
  const [countBasketItem, setCountBasketItem] = useState(0);
  const [pageContent, setPageContent] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  //const [show, setShow] = useState(false);
  // const handleShow = () => setShow(true);
  // const handleClose = () => setShow(false);
  //
  const navigate = useNavigate();

  // if (collapsed === false) document.body.classList.add("hiddenOverflow");
  // else document.body.classList.remove("hiddenOverflow");

  useEffect(() => {
    if (
      !_.isEmpty(ctx.basketInfo) &&
      !_.isEmpty(ctx.basketInfo.basketItemTemps) &&
      ctx.basketInfo.basketItemTemps.length > 0
    )
      setCountBasketItem(
        ctx.basketInfo.basketItemTemps.filter((e) => e.isDeleted === false)
          .length
      );
    else setCountBasketItem(0);
    setIsLogin(ctx.isAuth);
  }, [ctx.basketInfo, ctx.isAuth]);

  // function signOut() {
  //   //
  //   const result = ApiAuth.logout({
  //     refreshToken: ServiceStorage.getRefreshToken(),
  //   });

  //   ctx.setIsAuth(false);
  //   setCollapsed(true);
  //   navigate("");
  // }

  // function toggleNavbar() {
  //   setCollapsed(!collapsed);
  // }

  function callBack() {
    if (ctx.isAuth) {
      navigate("/profile");
    } else {
      //handleShow();
    }
  }
  useEffect(() => {
    getData();
  }, []);
  async function getData() {
    setLoadingData(true);
    try {
      const contactInfo = await ApiContact.getInfos();
      const contactInfoContent = JSON.parse(contactInfo?.content || []);
      setPageContent(contactInfoContent);
    } catch (error) {
      setLoadingData(false);
    } finally {
      setLoadingData(false);
    }
  }
  // function closeNavbar() {
  //   setCollapsed(true);
  // }

  return (
    <>
      <footer>
        {/* ***** mobile ******************************************* */}
        {isMobile ? (
          <>
            {/* {countBasketItem > 0 &&
              location.pathname !== "/payment" &&
              !location.pathname.includes("/order") &&
              !location.pathname.includes("/transaction") &&
              !location.pathname.includes("/wallet") &&
              !location.pathname.includes("/withdrow") && (
                <div
                  className="d-flex justify-content-between align-items-center text-white w-100 bg-danger px-3 py-2 position-fixed "
                  style={{
                    bottom: "56px",
                    zIndex: "1049",
                    borderTop: "1px solid #939393",
                  }}
                >
                  <div className="fs-075 fw-normal">
                    <div>
                      <span className=" fs-09">{countBasketItem}</span> سفارش
                    </div>
                    <div className="fw-bold fs-101">
                      <SplitNumber number={ctx?.basketInfo?.price} /> تومان
                    </div>
                  </div>
                  <div>
                    <Link
                      className="btn btn-light text-white fs-09"
                      to="/payment"
                    >
                      ادامه فرآیند خرید{" "}
                    </Link>
                  </div>
                </div>
              )} */}
            <Navbar
              expanded={!collapsed}
              variant=""
              expand={false}
              className="fixed-bottom border-0  bg-white"
              id="bottom-nav"
            >
              <div className="d-flex justify-content-around w-100 px-0 menu-bottom-icon">
                <span className="circle-bottom-nav"></span>
                <div>
                  <NavbarLinkItem
                    // closeCollapse={closeNavbar}
                    navbarItemHref="/"
                    exactLink="true"
                    styleNameClass=""
                    navbarItemIcon={<IconHome fillColor="#000" />}
                    navbarItemTitle="صفحه اصلی"
                  />
                </div>
                <div className="position-relative">
                  <NavbarLinkItem
                    // closeCollapse={closeNavbar}
                    navbarItemHref={
                      ctx.selectedCity?.englishName === undefined
                        ? "/c"
                        : `/c/${ctx.selectedCity?.englishName}`
                    }
                    exactLink="false"
                    styleNameClass=""
                    navbarItemIcon={<IconCategory fillColor="#000" />}
                    navbarItemTitle="لیست تفریحات"
                  />
                  <Link
                    to={
                      ctx.selectedCity?.englishName === undefined
                        ? "/c"
                        : `/c/${ctx.selectedCity?.englishName}`
                    }
                  >
                    <div class="red-square">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="slide-svg"
                        width="32"
                        height="32"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="#fff"
                          d="m240.287 127.394l-23.78-19.145l108.861-13.892l2.751 21.828zM180.746 107.7h-62.91l-17.88 44.576h136.067zm275.78 247.033a62.91 62.91 0 1 0-62.911 62.91a62.91 62.91 0 0 0 62.91-62.91zm-279.205 0a62.91 62.91 0 1 0-62.91 62.91a62.91 62.91 0 0 0 62.91-62.91M486 347.25a20.55 20.55 0 0 1-7.922 16.216a84.917 84.917 0 1 0-168.362 4.388H198.31a84.903 84.903 0 1 0-168.788-13.686a26.83 26.83 0 0 1-3.329-16.504l16.753-143.165a22.914 22.914 0 0 1 22.762-20.26h241.904a15 15 0 0 1 11.787 5.736l44.012 56.089l105.383 22.941zM337.815 239.255l-35.856-50.656h-93.265v50.683h129.135z"
                        />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="slide-svg"
                        width="32"
                        height="32"
                        viewBox="0 0 56 56"
                      >
                        <path
                          fill="#fff"
                          d="m34.656 7.879l12.915 12.914c4.124-4.102 4.288-9.305.327-13.242c-3.937-3.89-9.14-3.797-13.242.328m-2.343 2.367c-2.485 2.438-3.516 5.227-3.165 7.922L7.375 41.628c-.89.962-1.031 2.298.07 3.4l-3 3.867c-.304.374-.304.914.118 1.335l.68.704c.398.398.937.422 1.359.093l3.867-3.023c1.055 1.102 2.414.96 3.351.07l12.141-11.25v13.383c0 1.195.96 2.133 2.156 2.133a2.11 2.11 0 0 0 2.133-2.133V36.355l-.164-3.351l7.148-6.633c2.696.352 5.532-.75 7.97-3.21ZM9.766 43.551l20.672-21.89q.597.983 1.476 1.898a12 12 0 0 0 1.828 1.523L11.945 45.707Z"
                        />
                      </svg>
                      <svg
                        class="slide-svg"
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#fff"
                          fillRule="evenodd"
                          d="M2.25 11.88c-.01.177.015.39.065.818l.401 3.428A5.515 5.515 0 0 0 8.193 21h3.614a5.52 5.52 0 0 0 5.028-3.25H19a3.75 3.75 0 1 0 0-7.5h-2.279a2 2 0 0 0-.618-.22c-.174-.03-.39-.03-.82-.03H4.717c-.43 0-.645 0-.819.03a2 2 0 0 0-1.646 1.85m15.487-.13q.008.065.012.13c.01.177-.014.39-.064.818l-.401 3.428l-.016.124H19a2.25 2.25 0 0 0 0-4.5zM10.53 1.47a.75.75 0 0 1 0 1.06a.666.666 0 0 0 0 .94a2.164 2.164 0 0 1 0 3.06a.75.75 0 0 1-1.06-1.06c.26-.26.26-.68 0-.94a2.164 2.164 0 0 1 0-3.06a.75.75 0 0 1 1.06 0m-4.5 1.5a.75.75 0 0 1 0 1.06l-.116.116a.69.69 0 0 0-.064.904a2.19 2.19 0 0 1-.204 2.864l-.116.116a.75.75 0 0 1-1.06-1.06l.116-.116a.69.69 0 0 0 .064-.904a2.19 2.19 0 0 1 .204-2.864l.116-.116a.75.75 0 0 1 1.06 0m9.5 0a.75.75 0 0 1 0 1.06l-.116.116a.69.69 0 0 0-.064.904a2.19 2.19 0 0 1-.204 2.864l-.116.116a.75.75 0 1 1-1.06-1.06l.116-.116a.69.69 0 0 0 .064-.904a2.19 2.19 0 0 1 .204-2.864l.116-.116a.75.75 0 0 1 1.06 0"
                          clipRule="evenodd"
                        />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="slide-svg"
                        width="32"
                        height="32"
                        viewBox="0 0 36 36"
                      >
                        <path
                          fill="#fff"
                          d="M34 31q-1.65-.15-3-1.2c-.5-.5-1.2-.8-2-.8c-.7 0-1.5.3-2 .8c-.9.8-2 1.1-3.1 1.1c-1.2 0-2.4-.4-3.3-1.1c-1.2-1.1-3-1.1-4.1 0c-.9.8-2.1 1.2-3.4 1.2c-1.2 0-2.3-.4-3.2-1.2c-.6-.5-1.3-.8-2-.8c-.8 0-1.7.3-2.3.8c-1 .8-2.3 1.2-3.5 1.1V29c.8 0 1.7-.3 2.3-.9c1-.8 2.2-1.2 3.4-1.1c1.2 0 2.4.4 3.3 1.2c1.2 1.1 3 1.1 4.2 0c1.9-1.6 4.7-1.6 6.5 0c1.2 1.1 3 1.1 4.1 0c.9-.8 2.1-1.2 3.3-1.2c1.1 0 2.2.4 3 1.2c.6.5.8.8 1.8.8z"
                          class="clr-i-solid clr-i-solid-path-1"
                        />
                        <path
                          fill="#fff"
                          d="M4.1 26.2c.6-.5 1.2-.8 1.9-1V23c0-.6.4-1.1 1-1.1h25L28.4 25h.2c.8 0 1.6.2 2.2.5l2.5-2.2l.2-.2c.7-.9.5-2.1-.4-2.8c-.2-.2-.7-.3-1.1-.3H7c-1.7 0-3 1.3-3 3z"
                          class="clr-i-solid clr-i-solid-path-2"
                        />
                        <path
                          fill="#fff"
                          d="M14.9 18.9h-6c-1.1 0-2-.9-2-2c0-.4.1-.8.4-1.2l4.1-5.8c.6-.9 1.9-1.1 2.8-.5c.5.4.8 1 .8 1.6v7.9z"
                          class="clr-i-solid clr-i-solid-path-3"
                        />
                        <path
                          fill="#fff"
                          d="M24.3 18.9H16V6.4c0-1.1.9-2 2-2c.7 0 1.3.4 1.7 1L26 15.8c.6 1 .2 2.2-.7 2.7c-.3.2-.7.3-1 .4"
                          class="clr-i-solid clr-i-solid-path-4"
                        />
                        <path fill="none" d="M0 0h36v36H0z" />
                      </svg>
                    </div>
                  </Link>
                </div>
                <div>
                  <NavbarLinkItem
                    // closeCollapse={closeNavbar}
                    navbarItemHref="/basket"
                    exactLink="true"
                    navbarItemIcon={<IconBasket />}
                    navbarItemTitle=""
                    navbarbasketCount={countBasketItem}
                    navbarBadgeDisplay={true}
                    styleNameClass="basket mx-auto "
                  />
                </div>
                <div>
                  {isLogin ? (
                    <NavbarLinkItem
                      exactLink="true"
                      // closeCollapse={closeNavbar}
                      navbarItemHref="/order"
                      styleNameClass=""
                      navbarItemIcon={<IconClipBoard fillColor="#000" />}
                      navbarItemTitle="سفارشهای من"
                    />
                  ) : (
                    <NavbarLinkItem
                      exactLink="true"
                      // closeCollapse={closeNavbar}
                      navbarItemHref="/contact"
                      styleNameClass=""
                      navbarItemIcon={<IconCall fillColor="#000" />}
                      navbarItemTitle="تماس با ما"
                    />
                  )}
                </div>
                <div>
                  {" "}
                  <NavbarLinkItem
                    exactLink="true"
                    closeCollapse={callBack}
                    navbarItemHref={isLogin ? "/profile" : "/login"}
                    styleNameClass=""
                    navbarItemIcon={
                      isLogin ? (
                        <IconUserCheck fillColor="#000" />
                      ) : (
                        <IconUser fillColor="#000" />
                      )
                    }
                    navbarItemTitle={
                      !isLogin ? "ورود / ثبت نام" : "حساب کاربری"
                    }
                  />
                </div>
              </div>

              {/* {!collapsed ? (
              <></>
            ) : (
              <div className="fixed-top bg-white" style={{ height: "89%" }}>
                <AdvancedMenuItems
                  header={true}
                  advancedMenuTitle="منوی پیشرفته"
                  setCollapsed={setCollapsed}
                  advancedMenuLogo={<IconCategory size={18} />}
                />
                <AdvancedMenuItems
                  advancedMenuTitle="آب و هوای کیش"
                  setCollapsed={setCollapsed}
                  path="/weather"
                  advancedMenuLogo={<IconCategory size={18} />}
                />
                <AdvancedMenuItems
                  advancedMenuTitle="تماس باما"
                  setCollapsed={setCollapsed}
                  path="/contact"
                  advancedMenuLogo={<IconCategory size={18} />}
                />
                {isLogin && (
                  <div>
                    <AdvancedMenuItems
                      setCollapsed={setCollapsed}
                      path="/profile"
                      advancedMenuLogo={<IconCategory size={18} />}
                      advancedMenuTitle="پروفایل"
                    />
                    <AdvancedMenuItems
                      setCollapsed={setCollapsed}
                      path="/order"
                      advancedMenuLogo={<IconCategory size={18} />}
                      advancedMenuTitle="سفارش ها"
                    />{" "}
                    <AdvancedMenuItems
                      setCollapsed={setCollapsed}
                      path="/wallet"
                      advancedMenuLogo={<IconCategory size={18} />}
                      advancedMenuTitle=" کیف پول"
                    />
                  </div>
                )}
              </div>
            )} */}
            </Navbar>
          </>
        ) : (
          // ***** desktop *******************************************
          <>
            {/* <Container
              fluid
              className="bg-light-blue pt-5 text-gray-6 footer py-4"
            >
              <Container className="">
                مجموعه تفریحان مجموعه‌ای جوان و خلاق است که اقدام به ایجاد
                سامانه بومی برای رزرو تفریحات جزیره کیش با قیمت مناسب کرده است
                که شما می‌توانید در این سامانه علاوه بر مشاهده قیمت بروز هر
                تفریح، قوانین و اطلاعات هر تفریح، مشاهده عکس و کلیپ هر تفریح و
                وضعیت جوی جزیره کیش در هر زمان مشاهده نمایید. همچنین یکی دیگر از
                اهداف این مجموعه جلوگیری از سوءاستفاده‌های انجام شده توسط
                کلاهبرداران از مسافران جزیره کیش است که در این راستا اقدامات
                مؤثری انجام داده‌ایم. ما در مجموعه تفریحان در تلاش هستیم تا
                همواره بکوشیم که بهترین و سریع‌ترین خدمات را در هر ساعت از
                شبانه‌روز ارائه نماییم. رضایت مسافر از خدمات و همچنین جلوگیری از
                ایجاد مشکلات متعدد در زمان رزرو اولویت تفریحان می‌باشد و در این
                راه می‌کوشیم تا بهترین خود باشیم.
              </Container> 
            </Container>*/}
            <Container fluid className="bg-light-2 py-4">
              <Container>
                {loadingData ? (
                  <SkeletonTheme>
                    <div className="d-flex align-items-center justify-content-between">
                      <Skeleton height={25} width={200}></Skeleton>

                      <Skeleton height={25} width={200}></Skeleton>

                      <Skeleton height={25} width={200}></Skeleton>
                    </div>
                  </SkeletonTheme>
                ) : (
                  <div className="d-flex align-items-center justify-content-between">
                    {pageContent.Phones?.map((item) => (
                      <div>
                        <a
                          href={`tel:${item.Phone}`}
                          className="fw-bold text-gray-6 pe-1 d-inline-block"
                        >
                          {item.Phone}
                        </a>
                        {item.Title}
                      </div>
                    ))}
                  </div>
                )}
              </Container>
            </Container>
            <Container fluid className="bg-light text-gray-6 footer py-4">
              <Container className="footer">
                <Row>
                  <Col xl="8" className="pe-0">
                    <div className="d-flex">
                      <Link className="me-3 " to="/">
                        صفحه اصلی
                      </Link>
                      <Link
                        className="me-3 "
                        to={
                          ctx.selectedCity?.englishName === undefined
                            ? "/c"
                            : `/c/${ctx.selectedCity?.englishName}`
                        }
                      >
                        لیست تفریحات{" "}
                      </Link>
                      <Link className="me-3 " to="/contact">
                        ارتباط با ما
                      </Link>
                      <Link className="me-3 " to="/aboutUs">
                        درباره با ما
                      </Link>
                      <Link className="me-3 " to="/siteRoles">
                        قوانین و مقررات
                      </Link>
                      <Link className="me-3 " to="/weather">
                        آب و هوای کیش
                      </Link>
                      <Link className="me-3 " to="/s/kishportinfo">
                        اطلاعات حرکت شناورها از بندر چارک
                      </Link>
                    </div>
                    <div className="mt-3">
                      آدرس : جزیره کیش - بلوار میر مهنا - روبروی بازار پارس خلیج
                      - مرکز نوآوری کیش - طبقه 4 - واحد 401 - شرکت رایان سفر
                      نیکان کیش
                    </div>
                    <div className="fs-075 mt-2">
                      Copyright ©2024 - Tafrihan.com
                    </div>
                  </Col>
                  <Col className="text-end">
                    <div>
                      {/* <a
                        referrerPolicy="origin"
                        rel="noreferrer"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                      >
                        <img
                          referrerPolicy="origin"
                          className="rounded-3 h-100 "
                          src={eNamadImage}
                          alt="eNamad"
                          style={{ cursor: "pointer" }}
                          id="A32132KLXam6f2jcPJyV"
                        />
                      </a> */}
                      <a
                        className="d-inline-block bg-white rounded-3 p-1"
                        referrerPolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                      >
                        <img
                          alt="eNamad"
                          width="90px"
                          referrerPolicy="origin"
                          className="rounded-3 h-100 "
                          src={eNamadImage}
                          style={{ cursor: "pointer" }}
                          id="A32132KLXam6f2jcPJyV"
                        />
                      </a>
                    </div>

                    {/* <img
                      id="A32132KLXam6f2jcPJyV"
                      style={{
                        cursor: "pointer",
                        width: "6.7em",
                        display: "inline-block",
                      }}
                      referrerpolicy="origin"
                      className="rounded-3 h-100 "
                      onclick='window.open("https://Trustseal.eNamad.ir/logo.aspx?id=274889&amp;Code=A32132KLXam6f2jcPJyV","Popup","toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30")'
                      alt="enamad"
                      src={eNamadImage}
                    ></img> */}
                  </Col>
                </Row>
              </Container>
            </Container>
          </>
        )}
      </footer>
    </>
  );
}
export default FooterNav;

/* <Col xs='12' lg='5' className='d-flex justify-content-center justify-content-lg-end mt-3 mt-lg-0'>
<div className=' ' style={{ width: '90px', height: '90px' }}>
    <a referrerPolicy="origin"
        target="_blank" href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV">
        <img
            referrerPolicy="origin"
            className=' img-fluid  w-100 h-100'

            src="https://Trustseal.eNamad.ir/logo.aspx?id=274889&amp;Code=A32132KLXam6f2jcPJyV" alt="eNamad" style={{ cursor: "pointer" }} id="A32132KLXam6f2jcPJyV" />
    </a>
</div>
</Col> */
